var AStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { ModuleConfig } from "../../models/module-config.model";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { AppControllerService } from "../../../app-controller.service";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { ODataAction } from "../odata-query/odata-action.model";
import { ViewApplicationDocumentationComponent } from "../../../view-application/view-application-documentation/view-application-documentation.component";
import { CreateApplicationDocumentationComponent } from "../../../create-application/create-application-documentation/create-application-documentation.component";
import { AlertType } from "../../models/alert";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { SharedConstants } from "../../constants/shared.constants";
import { map } from "rxjs/operators";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { minLengthArray } from "../../classes/min-length-array-validator";
import { ViewApplicationDetailsAComponent } from "../../../view-application/modules/a/view-application-details-a/view-application-details-a.component";
import { ViewApplicationLocationAComponent } from "../../../view-application/modules/a/view-application-location-a/view-application-location-a.component";
import { CreateApplicationDetailsAComponent } from "../../../create-application/modules/a/create-application-details-a/create-application-details-a.component";
import { CreateApplicationLocationAComponent } from "../../../create-application/modules/a/create-application-location-a/create-application-location-a.component";
import { ApiAdvertisingConstants } from "../../constants/api-constants/api-advertising.constants";
import { phoneNumberValidator } from "../../classes/phone-number-validator";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { DatePipe } from "@angular/common";
import { CreateApplicationLocationAConstants } from "../../../create-application/modules/a/create-application-location-a/create-application-location-a.constants";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ApplicationType, "type"],
    [ApplicationHeadingEnum.CreatedDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "type"],
    [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"]
]);
export const AExpandListForApplicationSearch = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_A;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationMenuHeadings["Location"] = "Location details";
    CreateApplicationMenuHeadings["Details"] = "Application details";
    CreateApplicationMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationMenuHeadings["Agent"] = "Agent";
    CreateApplicationMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Property help";
    HeaderConfigurableTextTypes["Details"] = "Application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(CreateApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(CreateApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Summary"] = "Application summary";
    ViewApplicationMenuHeadings["Location"] = "Advertising details";
    ViewApplicationMenuHeadings["Details"] = "Application details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Summary, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export let AStrategyService = class AStrategyService extends AflaModuleStrategyService {
    static { AStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    applicationCreateService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    datePipe;
    http;
    appController;
    router;
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.Advertising;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiAdvertisingConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = AExpandListForApplicationSearch;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    savedApplication;
    constructor(saShortDatePipe, applicationSearchService, applicationCreateService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, datePipe, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.applicationCreateService = applicationCreateService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.datePipe = datePipe;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiAdvertisingConstants.URL}/${ApiAdvertisingConstants.FUNCTION_GET_MY_AFLA_ADVERTISING_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, AExpandListForApplicationSearch);
    }
    buildListFilter(list, column) {
        const params = AStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: AStrategyService_1.getRecipientName(AStrategyService_1.getFirstRecipient(application.applicant)),
            agent: AStrategyService_1.getRecipientName(AStrategyService_1.getFirstRecipient(application.applicantAgent)),
            type: application.type,
            startDate: this.saShortDatePipe.transform(application.createdDate),
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.Details, ViewApplicationDetailsAComponent],
            [ViewApplicationMenuHeadings.Location, ViewApplicationLocationAComponent],
            [ViewApplicationMenuHeadings.Documentation, ViewApplicationDocumentationComponent]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationMenuHeadings.Details, CreateApplicationDetailsAComponent],
            [CreateApplicationMenuHeadings.Location, CreateApplicationLocationAComponent],
            [CreateApplicationMenuHeadings.Documentation, CreateApplicationDocumentationComponent]
        ]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = AStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, AStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.cleanupAfterDestroy(this.postApplicationService(application)).subscribe((savedApplication) => {
            this.appController.showMessage(AStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
            this.resetForm();
            this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]).then();
        }, (error) => {
            this.appController.handleServerErrorMessage("create advertising application", error, CRUDOperation.Add);
        });
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        // @ts-ignore
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                application = this.setAdvertisementsGeometry(step.stepIndex, existingApplication, missingLookupsForZones);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                aApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this because the saved application object does not return with the latest property owners
                    const params = {
                        $expand: "point, polygon",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
                    };
                    this.cleanupAfterDestroy(this.getApplicationsQuery(params)).subscribe({
                        next: (response) => {
                            const point = response.value[0]?.point;
                            const polygon = response.value[0]?.polygon;
                            savedApplication.point = point;
                            savedApplication.polygon = polygon;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        }, error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.appController.showMessage(AStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FEEL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.aApplication.eLodgementStep;
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(AStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }
                    });
                }, error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiAdvertisingConstants.URL}/${applicationId}/${ApiAdvertisingConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    getCurrentFormName(step) {
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                formName = "advertisementsForm";
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetForm() {
        this.form.reset();
        this.form.get("advertisementsForm").get("advertisements").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiAdvertisingConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_TP_APPLICATIONS_BY_USER;
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === CreateApplicationMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === ViewApplicationMenuHeadings.Summary ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiAdvertisingConstants.URL}/${jobId}/${ApiAdvertisingConstants.FUNCTION_GET_APPLICATION_TYPE}`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("advertisementsForm") && this.form.get("advertisementsForm").get("advertisements")) {
            const advertisementsArray = this.form.get("advertisementsForm").get("advertisements");
            if (advertisementsArray.controls.length > 0) {
                return true;
            }
            else {
                this.appController.showMessage(CreateApplicationLocationAConstants.FEATURE_REQUIRED, AlertType.Warning);
                return false;
            }
        }
        else {
            this.appController.showMessage(CreateApplicationLocationAConstants.FEATURE_REQUIRED, AlertType.Warning);
            return false;
        }
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                this.form.get("detailsForm").get("description").reset();
                this.form.get("detailsForm").get("displayStartDate").reset();
                this.form.get("detailsForm").get("displayEndDate").reset();
                this.form.get("detailsForm").get("permanentApplicationDuration").reset();
                this.form.get("detailsForm").get("displayRemovalDate").reset();
                this.form.get("detailsForm").get("numberOfPosters").reset();
                this.form.get("detailsForm").get("nameOfBusiness").reset();
                this.form.get("detailsForm").get("notifySignageRemovalPeriod").reset();
                this.form.get("detailsForm").get("positionOfDisplay").reset();
                this.form.get("detailsForm").get("dimensionsH").reset();
                this.form.get("detailsForm").get("dimensionsW").reset();
                this.form.get("detailsForm").get("dimensionsD").reset();
                this.form.get("detailsForm").get("material").reset();
                this.form.get("detailsForm").get("colours").reset();
                this.form.get("detailsForm").get("frontalArea").reset();
                this.form.get("detailsForm").get("totalArea").reset();
                this.form.get("detailsForm").get("signType").reset();
                this.form.get("detailsForm").get("weight").reset();
                this.form.get("detailsForm").get("wattage").reset();
                this.form.get("detailsForm").get("contractorName").reset();
                this.form.get("detailsForm").get("contractorAddress").reset();
                this.form.get("detailsForm").get("contractorTelephone").reset();
                this.form.get("detailsForm").get("forSale").reset();
                this.form.get("detailsForm").get("onShow").reset();
                this.form.get("detailsForm").get("toLet").reset();
                this.form.get("detailsForm").get("sold").reset();
                this.form.get("detailsForm").get("constructionBoardSign").reset();
                this.form.get("detailsForm").get("otherOneYear").reset();
                this.form.get("detailsForm").get("groundSign").reset();
                this.form.get("detailsForm").get("flag").reset();
                this.form.get("detailsForm").get("sandwichBoard").reset();
                this.form.get("detailsForm").get("pylon").reset();
                this.form.get("detailsForm").get("wallSign").reset();
                this.form.get("detailsForm").get("buildingAttachment").reset();
                this.form.get("detailsForm").get("projectingWallSign").reset();
                this.form.get("detailsForm").get("wallPainted").reset();
                this.form.get("detailsForm").get("roofSign").reset();
                this.form.get("detailsForm").get("skySign").reset();
                this.form.get("detailsForm").get("veranda").reset();
                this.form.get("detailsForm").get("aerialSign").reset();
                this.form.get("detailsForm").get("windowSign").reset();
                this.form.get("detailsForm").get("schoolSign").reset();
                this.form.get("detailsForm").get("combinationSign").reset();
                this.form.get("detailsForm").get("underAwningSign").reset();
                this.form.get("detailsForm").get("flagSign").reset();
                this.form.get("detailsForm").get("canopy").reset();
                this.form.get("detailsForm").get("balcony").reset();
                this.form.get("detailsForm").get("electronicSign").reset();
                this.form.get("detailsForm").get("developmentBoard").reset();
                this.form.get("detailsForm").get("otherFiveYear").reset();
                this.form.get("detailsForm").get("nonIlluminatedBillboard").reset();
                this.form.get("detailsForm").get("digitalBillboard").reset();
                this.form.get("detailsForm").get("nonIlluminatedGantry").reset();
                this.form.get("detailsForm").get("digitalGantry").reset();
                this.form.get("detailsForm").get("internallyIlluminatedBillboard").reset();
                this.form.get("detailsForm").get("internallyIlluminatedGantry").reset();
                this.form.get("detailsForm").get("municipalConsumerAccountNumber").reset();
                this.form.get("detailsForm").get("personResponsibleId").reset();
                this.form.get("detailsForm").get("referenceNumber").reset();
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("advertisementsForm").get("advertisements").clear();
                this.form.get("advertisementsForm").get("isAdvetisingPermanentOrTemporary").reset();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    setAdvertisementsGeometry(stepIndex, existingApplication, missingLookupsForZones) {
        let application;
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const applicationTypeValue = selectedPropertyFormGroup.get("type").value;
        const isAdvertisingPermanentOrTemporaryValue = this.form.get("advertisementsForm").get("isAdvetisingPermanentOrTemporary").value;
        if (existingApplication) {
            application = existingApplication;
            application.isAdvetisingPermanentOrTemporary = isAdvertisingPermanentOrTemporaryValue;
            application.type = applicationTypeValue;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                moduleId: Number(this.appController.selectedModuleID),
                deleted: false,
                isAdvetisingPermanentOrTemporary: isAdvertisingPermanentOrTemporaryValue,
                type: applicationTypeValue,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                shape: "",
                wkid: 102100
            };
        if (isAdvertisingPermanentOrTemporaryValue === "permanent") {
            this.setApplicationPointData(application);
        }
        if (isAdvertisingPermanentOrTemporaryValue === "temporary") {
            this.setApplicationPolygonData(application);
        }
        return application;
    }
    setApplicationPointData(application) {
        const points = [];
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const centroid = selectedPropertyFormGroup.get("centroid").value;
        const geometry = selectedPropertyFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        points.push(`(${centroid.x} ${centroid.y})`);
        const pointShape = `POINT ${points.join(", ")}`;
        application.point = {
            id: 0,
            addressStreetInformation: selectedPropertyFormGroup.get("addressStreetInformation").value,
            shape: geometryJSON,
            wkid: 102100,
            deleted: false
        };
        application.shape = pointShape;
    }
    setApplicationPolygonData(application) {
        const points = [];
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        propertyArray.controls.forEach((selectedPropertyControl) => {
            const centroid = selectedPropertyControl.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
        });
        const polygonShape = `MULTIPOINT (${points.join(", ")})`;
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const geometry = selectedPropertyFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        application.polygon = {
            id: 0,
            areaOfDisplay: selectedPropertyFormGroup.get("areaOfDisplay").value,
            streetNames: selectedPropertyFormGroup.get("streetNames").value,
            propertyDescription: selectedPropertyFormGroup.get("propertyDescription").value,
            shape: geometryJSON,
            wkid: 102100,
            deleted: false
        };
        application.shape = polygonShape;
    }
    buildDetailsStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.shape = existingApplication.shape;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                referenceNumber: "",
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: false,
            };
        const date = new Date();
        const dateString = this.datePipe.transform(date, "yyyy-MM-dd");
        application.description = this.form.get("detailsForm").get("description").value;
        application.displayStartDate = this.form.get("detailsForm").get("displayStartDate").value === null ? dateString : this.form.get("detailsForm").get("displayStartDate").value;
        application.displayEndDate = this.form.get("detailsForm").get("displayEndDate").value === null ? dateString : this.form.get("detailsForm").get("displayEndDate").value;
        application.permanentApplicationDuration = this.form.get("detailsForm").get("permanentApplicationDuration").value;
        application.displayRemovalDate = this.form.get("detailsForm").get("displayRemovalDate").value === null ? dateString : this.form.get("detailsForm").get("displayRemovalDate").value;
        application.numberOfPosters = this.form.get("detailsForm").get("numberOfPosters").value === null ? 0 : this.form.get("detailsForm").get("numberOfPosters").value;
        application.nameOfBusiness = this.form.get("detailsForm").get("nameOfBusiness").value;
        application.notifySignageRemovalPeriod = this.form.get("detailsForm").get("notifySignageRemovalPeriod").value;
        application.positionOfDisplay = this.form.get("detailsForm").get("positionOfDisplay").value;
        application.dimensionsH = this.form.get("detailsForm").get("dimensionsH").value === null ? 0 : this.form.get("detailsForm").get("dimensionsH").value;
        application.dimensionsW = this.form.get("detailsForm").get("dimensionsW").value === null ? 0 : this.form.get("detailsForm").get("dimensionsW").value;
        application.dimensionsD = this.form.get("detailsForm").get("dimensionsD").value === null ? 0 : this.form.get("detailsForm").get("dimensionsD").value;
        application.material = this.form.get("detailsForm").get("material").value;
        application.colours = this.form.get("detailsForm").get("colours").value;
        application.frontalArea = this.form.get("detailsForm").get("frontalArea").value === null ? 0 : this.form.get("detailsForm").get("frontalArea").value;
        application.totalArea = this.form.get("detailsForm").get("totalArea").value === null ? 0 : this.form.get("detailsForm").get("totalArea").value;
        application.signType = this.form.get("detailsForm").get("signType").value;
        application.weight = this.form.get("detailsForm").get("weight").value === null ? 0 : this.form.get("detailsForm").get("weight").value;
        application.wattage = this.form.get("detailsForm").get("wattage").value === null ? 0 : this.form.get("detailsForm").get("wattage").value;
        application.contractorName = this.form.get("detailsForm").get("contractorName").value;
        application.contractorAddress = this.form.get("detailsForm").get("contractorAddress").value;
        application.contractorTelephone = this.form.get("detailsForm").get("contractorTelephone").value;
        application.forSale = this.form.get("detailsForm").get("forSale").value === null ? false : this.form.get("detailsForm").get("forSale").value;
        application.onShow = this.form.get("detailsForm").get("onShow").value === null ? false : this.form.get("detailsForm").get("onShow").value;
        application.toLet = this.form.get("detailsForm").get("toLet").value === null ? false : this.form.get("detailsForm").get("toLet").value;
        application.sold = this.form.get("detailsForm").get("sold").value === null ? false : this.form.get("detailsForm").get("sold").value;
        application.constructionBoardSign = this.form.get("detailsForm").get("constructionBoardSign").value === null ? false : this.form.get("detailsForm").get("constructionBoardSign").value;
        application.otherOneYear = this.form.get("detailsForm").get("otherOneYear").value;
        application.groundSign = this.form.get("detailsForm").get("groundSign").value === null ? false : this.form.get("detailsForm").get("groundSign").value;
        application.flag = this.form.get("detailsForm").get("flag").value === null ? false : this.form.get("detailsForm").get("flag").value;
        application.sandwichBoard = this.form.get("detailsForm").get("sandwichBoard").value === null ? false : this.form.get("detailsForm").get("sandwichBoard").value;
        application.pylon = this.form.get("detailsForm").get("pylon").value === null ? false : this.form.get("detailsForm").get("pylon").value;
        application.wallSign = this.form.get("detailsForm").get("wallSign").value === null ? false : this.form.get("detailsForm").get("wallSign").value;
        application.buildingAttachment = this.form.get("detailsForm").get("buildingAttachment").value === null ? false : this.form.get("detailsForm").get("buildingAttachment").value;
        application.projectingWallSign = this.form.get("detailsForm").get("projectingWallSign").value === null ? false : this.form.get("detailsForm").get("projectingWallSign").value;
        application.wallPainted = this.form.get("detailsForm").get("wallPainted").value === null ? false : this.form.get("detailsForm").get("wallPainted").value;
        application.roofSign = this.form.get("detailsForm").get("roofSign").value === null ? false : this.form.get("detailsForm").get("roofSign").value;
        application.skySign = this.form.get("detailsForm").get("skySign").value === null ? false : this.form.get("detailsForm").get("skySign").value;
        application.veranda = this.form.get("detailsForm").get("veranda").value === null ? false : this.form.get("detailsForm").get("veranda").value;
        application.aerialSign = this.form.get("detailsForm").get("aerialSign").value === null ? false : this.form.get("detailsForm").get("aerialSign").value;
        application.windowSign = this.form.get("detailsForm").get("windowSign").value === null ? false : this.form.get("detailsForm").get("windowSign").value;
        application.schoolSign = this.form.get("detailsForm").get("schoolSign").value === null ? false : this.form.get("detailsForm").get("schoolSign").value;
        application.combinationSign = this.form.get("detailsForm").get("combinationSign").value === null ? false : this.form.get("detailsForm").get("combinationSign").value;
        application.underAwningSign = this.form.get("detailsForm").get("underAwningSign").value === null ? false : this.form.get("detailsForm").get("underAwningSign").value;
        application.flagSign = this.form.get("detailsForm").get("flagSign").value === null ? false : this.form.get("detailsForm").get("flagSign").value;
        application.canopy = this.form.get("detailsForm").get("canopy").value === null ? false : this.form.get("detailsForm").get("canopy").value;
        application.balcony = this.form.get("detailsForm").get("balcony").value === null ? false : this.form.get("detailsForm").get("balcony").value;
        application.electronicSign = this.form.get("detailsForm").get("electronicSign").value === null ? false : this.form.get("detailsForm").get("electronicSign").value;
        application.developmentBoard = this.form.get("detailsForm").get("developmentBoard").value === null ? false : this.form.get("detailsForm").get("developmentBoard").value;
        application.otherFiveYear = this.form.get("detailsForm").get("otherFiveYear").value;
        application.nonIlluminatedBillboard = this.form.get("detailsForm").get("nonIlluminatedBillboard").value;
        application.digitalBillboard = this.form.get("detailsForm").get("digitalBillboard").value;
        application.nonIlluminatedGantry = this.form.get("detailsForm").get("nonIlluminatedGantry").value;
        application.digitalGantry = this.form.get("detailsForm").get("digitalGantry").value;
        application.internallyIlluminatedBillboard = this.form.get("detailsForm").get("internallyIlluminatedBillboard").value;
        application.internallyIlluminatedGantry = this.form.get("detailsForm").get("internallyIlluminatedGantry").value;
        application.municipalConsumerAccountNumber = this.form.get("detailsForm").get("municipalConsumerAccountNumber").value;
        application.personResponsibleId = this.form.get("detailsForm").get("personResponsibleId").value;
        application.referenceNumber = this.form.get("detailsForm").get("referenceNumber").value;
        const personResponsibleValue = this.form.get("detailsForm").get("personResponsible").value;
        const personResponsible = RecipientUtils.removeInvalidRecipientProperties(personResponsibleValue);
        application.personResponsible = personResponsible ? [personResponsible] : [];
        return application;
    }
    buildApplication(existingApplication) {
        return {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: "",
            type: "",
            wkid: 102100,
            eLodgementStep: 0,
            eLodgementComplete: true,
        };
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicant = [applicant];
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(existingApplication);
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicant: [applicant],
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantAgentFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantAgentFormValue);
        if (existingApplication) {
            existingApplication.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            existingApplication.applicantAgentNa = applicantAgentIsNullValue;
            existingApplication.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(existingApplication);
        }
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return existingApplication;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
            RecipientUtils.cleanPropertyOwners(existingApplication);
        }
        else {
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        }
        return application;
    }
    initForm() {
        this.form = new FormGroup({
            advertisementsForm: new FormGroup({
                advertisements: new FormArray([], [minLengthArray(1), Validators.required]),
                isAdvetisingPermanentOrTemporary: new FormControl(null, Validators.required),
                type: new FormControl(null)
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                permanentApplicationDuration: new FormControl(null),
                displayStartDate: new FormControl(null),
                displayEndDate: new FormControl(null),
                displayRemovalDate: new FormControl(null),
                numberOfPosters: new FormControl(null),
                applicationDuration: new FormControl(null),
                nameOfBusiness: new FormControl(null),
                notifySignageRemovalPeriod: new FormControl(null),
                positionOfDisplay: new FormControl(null),
                dimensionsH: new FormControl(0),
                dimensionsW: new FormControl(0),
                dimensionsD: new FormControl(0),
                material: new FormControl(null),
                colours: new FormControl(null),
                frontalArea: new FormControl(0),
                totalArea: new FormControl(0),
                signType: new FormControl(null),
                weight: new FormControl(0),
                wattage: new FormControl(0),
                contractorName: new FormControl(null),
                contractorAddress: new FormControl(null),
                contractorTelephone: new FormControl(null, phoneNumberValidator),
                forSale: new FormControl(false),
                onShow: new FormControl(false),
                toLet: new FormControl(false),
                sold: new FormControl(false),
                constructionBoardSign: new FormControl(false),
                otherOneYear: new FormControl(null),
                groundSign: new FormControl(false),
                flag: new FormControl(false),
                sandwichBoard: new FormControl(false),
                pylon: new FormControl(false),
                wallSign: new FormControl(false),
                buildingAttachment: new FormControl(false),
                projectingWallSign: new FormControl(false),
                wallPainted: new FormControl(false),
                roofSign: new FormControl(false),
                skySign: new FormControl(false),
                veranda: new FormControl(false),
                aerialSign: new FormControl(false),
                windowSign: new FormControl(false),
                schoolSign: new FormControl(false),
                combinationSign: new FormControl(false),
                underAwningSign: new FormControl(false),
                flagSign: new FormControl(false),
                canopy: new FormControl(false),
                balcony: new FormControl(false),
                electronicSign: new FormControl(false),
                developmentBoard: new FormControl(false),
                otherFiveYear: new FormControl(null),
                nonIlluminatedBillboard: new FormControl(null),
                digitalBillboard: new FormControl(null),
                nonIlluminatedGantry: new FormControl(null),
                digitalGantry: new FormControl(null),
                internallyIlluminatedBillboard: new FormControl(null),
                internallyIlluminatedGantry: new FormControl(null),
                municipalConsumerAccountNumber: new FormControl(null),
                personResponsibleId: new FormControl(null),
                personResponsible: new FormControl([]),
                referenceNumber: new FormControl(null)
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null),
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            })
        });
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: DatePipe },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
AStrategyService = AStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root"
    })
], AStrategyService);
